/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalServiceInfoDto
 */
export interface AdditionalServiceInfoDto {
    /**
     * Название дополнительной услуги
     * @type {string}
     * @memberof AdditionalServiceInfoDto
     */
    name: string;
    /**
     * Описание дополнительной услуги
     * @type {string}
     * @memberof AdditionalServiceInfoDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the AdditionalServiceInfoDto interface.
 */
export function instanceOfAdditionalServiceInfoDto(value: object): value is AdditionalServiceInfoDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AdditionalServiceInfoDtoFromJSON(json: any): AdditionalServiceInfoDto {
    return AdditionalServiceInfoDtoFromJSONTyped(json, false);
}

export function AdditionalServiceInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalServiceInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

  export function AdditionalServiceInfoDtoToJSON(json: any): AdditionalServiceInfoDto {
      return AdditionalServiceInfoDtoToJSONTyped(json, false);
  }

  export function AdditionalServiceInfoDtoToJSONTyped(value?: AdditionalServiceInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
    };
}

